// extracted by mini-css-extract-plugin
export default {"row":"PullRequestRow-module__row--ogYMh"};